import type { RouteRecordRaw } from 'vue-router'
import { routePaths } from '@/router/paths.ts'
import { routeNames } from '@/router/names.ts'
import { validateResetPasswordTokenGuard } from '@/router/guards/validateResetPasswordTokenGuard.ts'
import { isChildProtectAcceptedGuard } from '@/router/guards/isChildProtectAcceptedGuard.ts'
import { messageCategoryGuard } from '@/router/guards/messageCategoryGuard.ts'
import { validateGuardianTermsGuard } from '@/router/guards/validateGuardianTermsGuard.ts'

export const routes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: { name: routeNames.LOGIN_VIEW_NAME },
    },
    {
        path: routePaths.AUTH_VIEW_PATH,
        component: () => import('../layouts/AuthLayout.vue'),
        meta: {
            isGuestRoute: true,
        },
        children: [
            {
                path: '',
                name: routeNames.LOGIN_VIEW_NAME,
                component: () => import('../views/LoginView.vue'),
            },
            {
                path: routePaths.FORGOT_PASSWORD_VIEW_PATH,
                name: routeNames.FORGOT_PASSWORD_VIEW_NAME,
                component: () => import('../views/ForgotPasswordView.vue'),
            },
            {
                path: routePaths.FORGOT_PASSWORD_SET_NEW_PASSWORD_VIEW_PATH,
                name: routeNames.FORGOT_PASSWORD_SET_NEW_PASSWORD_VIEW_NAME,
                component: () => import('../views/ForgotPasswordSetNewPasswordView.vue'),
                beforeEnter: validateResetPasswordTokenGuard,
                props: (route) => ({ token: route.params.token }),
            },
        ],
    },
    {
        path: routePaths.ROOT_PATH_WITH_SUB_ACCOUNT_ID,
        component: () => import('../layouts/MainLayout.vue'),
        meta: {
            isGuestRoute: false,
        },
        children: [
            {
                path: '',
                name: routeNames.HOME_VIEW_NAME,
                component: () => import('../views/HomeView.vue'),
            },
            {
                path: routePaths.SUB_ACCOUNT_PROFILE_VIEW_PATH,
                name: routeNames.SUB_ACCOUNT_PROFILE_VIEW_NAME,
                component: () => import('../views/SubAccountView.vue'),
            },
            {
                path: routePaths.REPORTS_VIEW_PATH,
                name: routeNames.REPORTS_VIEW_NAME,
                component: () => import('../views/ReportsView.vue'),
            },
            {
                path: routePaths.MESSAGES_VIEW_PATH,
                name: routeNames.MESSAGES_VIEW_NAME,
                component: () => import('../views/MessagesView.vue'),
                children: [
                    {
                        path: routePaths.MESSAGES_LIST_VIEW_PATH,
                        name: routeNames.MESSAGES_LIST_VIEW_NAME,
                        component: () => import('../views/MessagesListView.vue'),
                        beforeEnter: messageCategoryGuard,
                    },
                    {
                        path: routePaths.MESSAGE_DETAILS_VIEW_PATH,
                        name: routeNames.MESSAGE_DETAILS_VIEW_NAME,
                        component: () => import('../views/MessageDetailsView.vue'),
                        beforeEnter: messageCategoryGuard,
                    },
                    {
                        path: routePaths.MESSAGE_EDIT_VIEW_PATH,
                        name: routeNames.MESSAGE_EDIT_VIEW_NAME,
                        component: () => import('../views/MessageEditView.vue'),
                        beforeEnter: messageCategoryGuard,
                    },
                ],
            },
            {
                path: routePaths.REPORT_EDIT_VIEW_PATH,
                name: routeNames.REPORT_EDIT_VIEW_NAME,
                component: () => import('../views/ReportEditView.vue'),
            },
        ],
    },
    {
        path: routePaths.GUARDIAN_TERMS_VIEW_PATH,
        component: () => import('../layouts/TermsAcceptanceLayout.vue'),
        beforeEnter: validateGuardianTermsGuard,
        meta: {
            isGuestRoute: false,
            isPublicRoute: false,
            isTermsRoute: true,
        },
        children: [
            {
                path: '',
                name: routeNames.GUARDIAN_TERMS_VIEW_NAME,
                component: () => import('../views/GuardianTermsView.vue'),
                props: (route) => {
                    return {
                        subAccountId: route.params.subAccountId
                            ? String(route.params.subAccountId)
                            : null,
                    }
                },
            },
        ],
    },
    {
        path: routePaths.CHILD_PROTECTION_VIEW_PATH,
        name: routeNames.CHILD_PROTECTION_VIEW_NAME,
        component: () => import('../views/ChildProtectionView.vue'),
        beforeEnter: isChildProtectAcceptedGuard,
        meta: {
            isPublicRoute: true,
        },
    },
    {
        path: routePaths.INVITATION_VIEW_PATH,
        name: routeNames.INVITATION_VIEW_NAME,
        component: () => import('../views/InvitationView.vue'),
        meta: {
            isPublicRoute: true,
        },
    },

    {
        path: routePaths.PAGE_NOT_FOUND_VIEW_PATH,
        name: routeNames.PAGE_NOT_FOUND_VIEW_NAME,
        component: () => import('../views/PageNotFoundView.vue'),
        meta: {
            isPublicRoute: true,
        },
    },
]
